




















































import { Component, Vue } from "vue-property-decorator";
import CellarsList from "@/components/cellars/CellarsList.vue";
import { UtilitiesFunctions, UtilitiesRequests } from "@/helpers";
import Region from "@/models/region";
import "@/plugins/metaHeadful";

@Component({
  components: {
    CellarsList
  }
})
export default class Cellars extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  regions?: Region[] = [];
  selectedRegions?: Region[] = [];
  mounted() {
    UtilitiesRequests.getRegionsV2().then((response: Region[]) => {
      this.regions = response;
    });
  }
  
 
  handleAppendClick() {
    // @ts-ignore
    this.$refs["regionSelect"].blur();
  }
}
